<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>Thanks to Cecile Dehopre and Eleonora Zimmermann of Doctors without Borders (MSF); Max von Kreyfelt, Alphonse Muambi and Pim van Galen at Café Weltschmerz; Lina Ruiz and Bas van Abel of Fairphone, Vladimirs Bondars and Jessica Walker of Dukascopy TV; Rob King; my publishers at Austin Macauley; and all the people who like my stories. A special thanks to Dr Fritjof Capra, Dr Pier Luigi Luisi, Henk Hadders, Javier Livas Cantu, Paul Pangaro, Mick Ashby and all systems thinkers and cyberneticians who confirm that systems science provides answers which can help us solve global conflicts and ensure long-term survival for all.</p>
<p><em>‘This world needs leaders who are true leaders and who can lead without causing those who are to be led to suffer.’</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?4b58b8ac